// Image SVG de fallback (No Image)
export const getNoImageSVG = () => {
  return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9Ijc1IiBoZWlnaHQ9Ijc1IiBmaWxsPSIjRjBGMEYwIi8+CjxwYXRoIGQ9Ik0zNy41IDI1TDUwIDM3LjVMMzcuNSA1MEwyNSAzNy41TDM3LjUgMjVaIiBmaWxsPSIjQ0NDQ0NDIi8+Cjx0ZXh0IHg9IjM3LjUiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiM5OTk5OTkiPk5vIEltYWdlPC90ZXh0Pgo8L3N2Zz4K';
};

// Construire l'URL de l'image du produit depuis les custom_attributes Magento
export const buildProductImageUrl = (customAttributes) => {
  if (!customAttributes || customAttributes.length === 0) {
    return getNoImageSVG();
  }

  const imageAttribute = customAttributes.find(attr => 
    attr.attribute_code === 'image' || 
    attr.attribute_code === 'small_image' || 
    attr.attribute_code === 'thumbnail'
  );

  if (imageAttribute && imageAttribute.value) {
    return `https://rullier-preprod.ova-consulting.fr/media/catalog/product/${imageAttribute.value}`;
  }

  return getNoImageSVG();
};

// Gestionnaire d'erreur d'image
export const handleImageError = (e) => {
  e.target.src = getNoImageSVG();
};
